import React, { useRef, useState, useEffect, useCallback } from "react";
import {
  Player,
  ControlBar,
  ReplayControl,
  ForwardControl,
  VolumeMenuButton,
  BigPlayButton,
} from "video-react";
import "video-react/dist/video-react.css";
import "./styles.css";
import MovieInfoHeader from "../movie-info-header";

export default function MoovPlayer({
  navigate,
  movie_data,
  watch_data,
  setWatchData,
  next_episode,
}) {
  const playerRef = useRef(null);

  const [isPlaying, setIsPlaying] = useState(false);
  const [showButtonSkipOpening, setShowButtonSkipOpening] = useState(false);
  const [showButtonNextEpisode, setShowButtonNextEpisode] = useState(false);

  const handleChange = useCallback((currentTime, watch, nextWatch) => {
    if (watch?.media_type === "tv" && currentTime > 1) {
      const startOpening = Number(watch?.start_opening) || 0;
      const endOpening = Number(watch?.end_opening) || 0;

      if (endOpening) {
        const inOpeningRange =
          currentTime >= startOpening && currentTime <= endOpening;
        setShowButtonSkipOpening(inOpeningRange);
      } else {
        setShowButtonSkipOpening(false);
      }

      if (Number(watch?.show_next) > 0 && nextWatch?.season_episode) {
        const inSkipRange = currentTime >= Number(watch?.show_next);
        setShowButtonNextEpisode(inSkipRange);
      } else {
        setShowButtonNextEpisode(false);
      }
    } else {
      setShowButtonNextEpisode(false);
      setShowButtonSkipOpening(false);
    }
  }, []);

  useEffect(() => {
    if (!playerRef.current) return;

    const player = playerRef.current;

    const handleStateChange = (state) => {
      handleChange(state.currentTime, watch_data, next_episode);
    };

    const unsubscribe = player.subscribeToStateChange(handleStateChange);

    return () => unsubscribe();
  }, [handleChange, watch_data, next_episode]);

  const handlePlay = () => {
    if (playerRef.current) {
      playerRef.current.play();
      setIsPlaying(true);
    }
  };

  const skipOpening = () => {
    if (playerRef.current && Number(watch_data?.end_opening)) {
      playerRef.current.seek(Number(watch_data.end_opening));
      setShowButtonSkipOpening(false);
    }
  };

  const skipEpisode = () => {
    setWatchData(next_episode);
    setShowButtonNextEpisode(false);
    setShowButtonSkipOpening(false);
    setIsPlaying(false);
    // navigate(...)
  };

  return (
    <>
      <Player
        ref={playerRef}
        playsInline
        fluid={false}
        width="100%"
        height="100%"
        poster={`https://image.tmdb.org/t/p/original${watch_data?.episode_details?.still_path}`}
        src={watch_data?.src}
      >
        {!isPlaying && (
          <BigPlayButton position="center" className="default-play-button" />
        )}

        <ControlBar autoHide>
          <MovieInfoHeader movie_data={movie_data} watch_data={watch_data} />
          <ReplayControl seconds={10} order={1.1} />
          <ForwardControl seconds={10} order={1.2} />
          <VolumeMenuButton vertical order={1.3} />
        </ControlBar>

        {!isPlaying && (
          <MovieInfoHeader movie_data={movie_data} watch_data={watch_data} />
        )}

        <div className="div-buttons-proximo-ep">
          {showButtonSkipOpening && (
            <section>
              <button onClick={skipOpening} className="bt-header-player">
                Pular Abertura
              </button>
            </section>
          )}

          {showButtonNextEpisode && (
            <section>
              <button className="bt-header-player" onClick={skipEpisode}>
                <i className="fa-solid fa-forward-fast"></i> Próximo Episódio
              </button>
            </section>
          )}
        </div>
      </Player>

      {!isPlaying && (
        <div className="container-custom-play-button" onClick={handlePlay}>
          <button className="custom-play-button">
            <span>▶</span>
          </button>
        </div>
      )}
    </>
  );
}
